import script from "./ServerSecurityTab.vue?vue&type=script&setup=true&lang=js"
export * from "./ServerSecurityTab.vue?vue&type=script&setup=true&lang=js"

import "./ServerSecurityTab.vue?vue&type=style&index=0&id=41d0b6ac&lang=scss"

const __exports__ = script;

export default __exports__